// Test implementacji chatbota
import React from 'react';
import { SimpleChatWidget } from '@/modules/chatbot/components/SimpleChatWidget';
import { MessageSquare, CheckCircle, Users, Clock, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const TestChatbot: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      {/* Simple Header */}
      <div className="bg-gray-900/50 backdrop-blur-sm border-b border-gray-700">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 text-gray-300 hover:text-white transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              Powrót
            </button>
            <h2 className="text-xl font-semibold text-amber-500">PlexiSystem</h2>
          </div>
        </div>
      </div>
      
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-amber-400 to-amber-600 bg-clip-text text-transparent">
            Test Chatbota AI
          </h1>
          <p className="text-gray-300 mb-8 text-lg">
            Wypróbuj naszego inteligentnego asystenta powered by Claude AI
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            {/* Instrukcje */}
            <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700">
              <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
                <MessageSquare className="w-5 h-5 text-amber-500" />
                Jak testować?
              </h2>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-green-500 mt-0.5" />
                  <span>Kliknij ikonę czatu w prawym dolnym rogu</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-green-500 mt-0.5" />
                  <span>Wypełnij formularz kontaktowy</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-green-500 mt-0.5" />
                  <span>Zadaj pytania o produkty z plexi</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-green-500 mt-0.5" />
                  <span>Sprawdź automatyczne zbieranie leadów</span>
                </li>
              </ul>
            </div>
            
            {/* Przykładowe pytania */}
            <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700">
              <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
                <Users className="w-5 h-5 text-amber-500" />
                Przykładowe pytania
              </h2>
              <ul className="space-y-2 text-gray-300 text-sm">
                <li className="bg-gray-700/50 p-2 rounded">"Jakie rodzaje plexi oferujecie?"</li>
                <li className="bg-gray-700/50 p-2 rounded">"Czy wykonujecie cięcie na wymiar?"</li>
                <li className="bg-gray-700/50 p-2 rounded">"Jaki jest czas realizacji zamówienia?"</li>
                <li className="bg-gray-700/50 p-2 rounded">"Czy macie plexi antybakteryjne?"</li>
                <li className="bg-gray-700/50 p-2 rounded">"Chciałbym zamówić osłony z plexi"</li>
              </ul>
            </div>
          </div>
          
          {/* Status */}
          <div className="bg-gradient-to-r from-amber-500/10 to-amber-600/10 rounded-lg p-6 border border-amber-500/30">
            <h3 className="text-lg font-semibold mb-2 flex items-center gap-2">
              <Clock className="w-5 h-5 text-amber-500" />
              Status czatbota
            </h3>
            <p className="text-gray-300">
              Czatbot jest aktywny i gotowy do rozmowy. Widget powinien być widoczny w prawym dolnym rogu ekranu.
              Odpowiedzi są generowane przez Claude AI w czasie rzeczywistym.
            </p>
          </div>
        </div>
      </div>
      
      {/* Chatbot Widget - wersja bez formularza */}
      <SimpleChatWidget />
    </div>
  );
};

export default TestChatbot;